export default __webpack_public_path__ + "static/media/employees.c1e967d3.svg";